import type { OfficeSection } from '../../shared/components/office-sections';

/** The sections a user's permissions show in the nav. The server still decides; this only hides links. */
export function visibleSections(sections: readonly OfficeSection[], permissions: readonly string[]): OfficeSection[] {
  return sections.filter((section) =>
    Array.isArray(section.permission) ? section.permission.some((permission) => permissions.includes(permission)) : permissions.includes(section.permission),
  );
}

/** Where `/` lands: the first section the user can open, so a user without dispatch (a report viewer) is not sent to a page that refuses them. */
export function homePath(sections: readonly OfficeSection[], permissions: readonly string[]): string {
  const [first] = visibleSections(sections, permissions);
  return first ? `/${first.slug}` : '/account';
}
